import React from "react";
import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";

const NdaInput = ({ value, onChange, className, placeholder, ...props }) => {

  const { data, isLoading, error } = useFetch({
    queryKey: ["case_studies", "nda-levels"],
    queryFn: async () => {
      const response = await getDirectusField("case_studies", "nda_level");

      const data = response.meta.options.choices.map((nda_level) => {
        return { name: nda_level.text, id: nda_level.value };
      });
      return data;
    },
    select: (data) =>
      remove?.length > 0 ? data.filter((nda_level) => !remove.includes(nda_level.text)) : data,
  });

  return (
    <EvtSelect
      value={value}
      onChange={onChange}
      className={className}
      data={data}
      isLoading={isLoading}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default NdaInput;
